import { upperFirstChat } from './index'
// import axios from 'axios'
// const isServer = process.env.VUE_ENV === 'server'
const defaultStore = {
  state: {},
  mutations: {},
  actions: {},
  getters: {}
}

export const DISABLED_ACTION_COMMIT = 'DISABLED_ACTION_COMMIT'

/**
 *
 * @param {Object} config.store
 * @param {String} config.name 用于生成驼峰形式的`fetch${name}`的action和`set${name}`mutation
 * @param {Promise} config.api 请求方法
 * @param {any} config.defaultValue 默认值
 * @param {Function} config.handle 接收请求返回的数据，返回处理过的数据，默认使用data
 */
export const registerStoreItem = ({
  store,
  name,
  api,
  defaultValue = null,
  handle = res => res.data.data
}) => {
  if (!store || !name || !api) {
    return new Error('缺少参数')
  }
  const _store = {
    ...defaultStore,
    ...store
  }
  const upName = upperFirstChat(name)
  const mutationName = `set${upName}`
  if (typeof _store.state === 'function') {
    const getState = _store.state
    _store.state = () => {
      return {
        ...getState(),
        [name]: defaultValue
      }
    }
  } else {
    _store.state[name] = defaultValue
  }
  _store.mutations[mutationName] = (state, payload) => (state[name] = payload)
  _store.actions[`fetch${upName}`] = ({ commit, dispatch, state }, params) => {
    // if (isServer && rootState.cookie) {
    //   axios.defaults.headers.common.cookie = rootState.cookie
    // }
    const fpromise = api(params)
    // if (isServer) {
    //   axios.defaults.headers.common.cookie = ''
    // }
    fpromise
      .then(res => {
        const resData = handle(res, { commit, dispatch, state, params })
        if (res.seo || (res.data && res.data.seo)) {
          commit('setMeta', res.seo || res.data.seo, { root: true })
        }
        resData !== DISABLED_ACTION_COMMIT && commit(mutationName, resData)
        return resData
      })
      .catch(e => {
        return Promise.reject(e)
      })
    return fpromise
  }
  return _store
}
